<template>
	<main class="new-accommodation">
		<section class="new-accommodation__content">
			<div class="new-accommodation__inner new-layout-container">
				<img class="new-accommodation__icon" src="/static/buttons/new/hotel-reservation.svg" alt="">

				<div class="new-accommodation__accent"></div>
				<h1>{{content.title}}</h1>
				<p class="new-accommodation__lead">{{content.lead}}</p>

				<div class="new-accommodation__items">
					<article
						v-for="item in content.items"
						:key="item.number"
						class="new-accommodation__item"
					>
						<span class="new-accommodation__number">{{item.number}}</span>
						<h2>{{item.title}}</h2>
						<p>{{item.text}}</p>
					</article>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	computed: {
		content() {
			return translate(this.$store.state.language).staticPages.accommodation;
		},
	},
};
</script>

<style scoped lang="scss">
.new-accommodation {
	background: #ffffff;
	color: #4c4b4b;
}

.new-accommodation__content {
	padding: 83px 0 86px;
}

.new-accommodation__inner {
	padding: 0;
}

.new-accommodation__icon {
	display: block;
	width: 40px;
	height: 40px;
	object-fit: contain;
}

.new-accommodation__accent {
	width: 44px;
	height: 4px;
	margin-top: 12px;
	margin-bottom: 18px;
	background: #5da3bd;
}

.new-accommodation h1 {
	margin: 0 0 16px;
	color: #4c4b4b;
	font-size: 40px;
	font-weight: 500;
	line-height: 47px;
	letter-spacing: 0;
}

.new-accommodation__lead {
	max-width: 1458px;
	margin: 0;
	color: #4c4b4b;
	font-size: 22px;
	font-weight: 400;
	line-height: 35px;
}

.new-accommodation__items {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 347px));
	justify-content: space-between;
	gap: 48px 32px;
	margin-top: 82px;
}

.new-accommodation__item {
	min-width: 0;
	color: #4c4b4b;
}

.new-accommodation__number {
	display: block;
	margin-bottom: 10px;
	color: #5da3bd;
	font-size: 80px;
	font-weight: 500;
	line-height: 94px;
}

.new-accommodation__item h2 {
	min-height: 70px;
	margin: 0 0 42px;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 500;
	line-height: 35px;
	letter-spacing: 0;
}

.new-accommodation__item p {
	margin: 0;
	color: #4c4b4b;
	font-size: 25px;
	font-weight: 400;
	line-height: 35px;
}

@media (max-width: 1180px) {
	.new-accommodation__items {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 720px) {
	.new-accommodation__content {
		padding: 58px 0 72px;
	}

	.new-accommodation h1 {
		font-size: 34px;
		line-height: 40px;
	}

	.new-accommodation__lead {
		font-size: 18px;
		line-height: 30px;
	}

	.new-accommodation__items {
		grid-template-columns: 1fr;
		margin-top: 56px;
	}

	.new-accommodation__item h2 {
		min-height: 0;
		margin-bottom: 18px;
	}

	.new-accommodation__item p {
		font-size: 18px;
		line-height: 30px;
	}
}

@media (max-width: 420px) {
	.new-accommodation__number {
		font-size: 62px;
		line-height: 72px;
	}

	.new-accommodation__item h2 {
		font-size: 22px;
		line-height: 30px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/accommodation/Accommodation.vue